import { Store, AnyAction } from 'redux';
import State from 'store/State';
import {
    requestProgressInProgressAction,
    requestProgressSuccessAction,
    requestProgressErrorAction,
    requestProgressAddRequest,
    requestProgressAddResponse,
} from './store/actions';
import { isIndigoApiError } from 'communication/IndigoApiError';
import {
    ApiErrorResponseInfo,
    ApiRequestInfo,
    ApiRequestOptions,
    ApiResponseInfo,
    buildErrorResponseInfo,
} from 'communication/ApiCallInfo';

export default class RequestProgressService {
    public store: Store<State, AnyAction> | undefined;

    public async invokeAndMonitorRequest<T>(
        key: string,
        apiCall: (options: ApiRequestOptions) => Promise<T>
    ): Promise<T> {
        if (!this.store) {
            throw new Error('store must be set');
        }

        this.store.dispatch(requestProgressInProgressAction(key));

        try {
            const result = await apiCall(this.buildOptions(key));
            this.store.dispatch(requestProgressSuccessAction(key));
            return result;
        } catch (error) {
            const errorInfo = buildErrorResponseInfo(error);
            this.store.dispatch(
                requestProgressErrorAction(
                    key,
                    errorInfo.message ? errorInfo.message : 'API Error',
                    errorInfo.status,
                    errorInfo.data
                )
            );

            throw error;
        }
    }

    private buildOptions(key: string): ApiRequestOptions {
        const onPending = (requestInfo: ApiRequestInfo) => {
            this.store!.dispatch(requestProgressAddRequest(key, requestInfo));
        };
        const onResponse = (
            requestInfoId: string,
            responseInfo: ApiResponseInfo
        ) => {
            this.store!.dispatch(
                requestProgressAddResponse(key, requestInfoId, responseInfo)
            );
        };
        const onError = (
            requestInfoId: string,
            responseErrorInfo: ApiErrorResponseInfo
        ) => {
            this.store!.dispatch(
                requestProgressAddResponse(
                    key,
                    requestInfoId,
                    responseErrorInfo
                )
            );
        };
        return { onPending, onResponse, onError };
    }
}

export function buildErrorMessage(error: unknown, message: string) {
    if (isIndigoApiError(error)) {
        return error.message;
    }
    return message;
}
